type NumberInputValidationResult = null | {
  key: string;
  value: string;
  substitutions?: { [key: string]: string | number | undefined };
};

/**
 * Creates a validation function, that can be used to validate
 * NumberInput input.
 */
export function createNumberInputInputValidationFn(
  min: number | undefined,
  max: number | undefined,
): (input: string | number | undefined) => NumberInputValidationResult {
  return function (input: string | number | undefined) {
    const negativesAllowed = !min || min <= 0;
    const maxValue = max ?? Number.MAX_VALUE;
    const minValue = min ?? Number.MIN_VALUE;
    const isNumber = typeof input === 'number';
    const number = isNumber
      ? (input as number)
      : Number.parseInt((input as string) ?? '0');

    if (input === '' || Number.isNaN(number)) {
      return {
        key: 'number_input.error_nan',
        value: 'Bitte geben Sie eine gültige Zahl ein.',
      };
    } else if (!negativesAllowed && input && String(input).startsWith('-')) {
      return {
        key: 'number_input.error_no_negatives',
        value: 'Es sind nur positive Zahlen erlaubt.',
      };
    } else if (number > maxValue) {
      return {
        key: 'number_input.error_max_value',
        value: 'Es sind nur Zahlen bis {{maxValue}} erlaubt.',
        substitutions: { maxValue },
      };
    } else if (number < minValue) {
      return {
        key: 'number_input.error_min_value',
        value: 'Es sind nur Zahlen bis {{minValue}} erlaubt.',
        substitutions: { minValue },
      };
    }

    return null;
  };
}
